import { getCoursesAsync } from '../reducers/courseSlice';
import { getApiAccessToken } from '../auth/auth';

import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { AppDispatch, RootState } from '../reducers/store';
import { useDispatch, useSelector } from 'react-redux';
import { Group } from '../model/group';
import { getGroupsAsync } from '../reducers/groupSlice';
import { MainView } from './main';
import { getGroupUsersAsync, getProgramUsersAsync, getUsersAsync } from '../reducers/userSlice';
import { getUserCertificationsAsync } from '../reducers/certificationSlice';
import { Program } from '../model/program';
import { getProgramsAsync } from '../reducers/programSlice';

export interface DataLoaderProps {
  target: string
}

export const DataLoaderView: React.FC<DataLoaderProps> = (props: DataLoaderProps) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const dispatch: AppDispatch = useDispatch();

    const currentGroup: Group | null = useSelector((state: RootState) => state.groups.currentGroup);
    const currentProgram: Program | null = useSelector((state: RootState) => state.programs.currentProgram);

    useEffect(() => {
      (async function() {
        const accessToken = await getApiAccessToken(instance, activeAccount);
          
        dispatch(getUsersAsync({accessToken}))
        dispatch(getGroupsAsync({accessToken}))
        dispatch(getProgramsAsync({accessToken}))
        dispatch(getCoursesAsync({accessToken}))

        if (currentGroup) {
          dispatch(getGroupUsersAsync({accessToken, groupId: currentGroup.id}))
        }
        
        if (currentProgram) {
          dispatch(getProgramUsersAsync({accessToken, programId: currentProgram.id}))
          dispatch(getUserCertificationsAsync({accessToken, programId: currentProgram.id}))
        }
  
      })();
    }, []);

    return (
        <MainView target={props.target}/>
    )
}